/**
 * Image manifest. Every image on the site is referenced by key, so swapping
 * a placeholder for a real photograph is a one-line change here.
 * `w` / `h` drive both the reserved aspect ratio and the dimension label
 * shown on ImageWithCaption.
 */
const P = (w, h) => `${process.env.PUBLIC_URL || ""}/images/placeholders/${w}x${h}.jpg`;

const R = (file) => `${process.env.PUBLIC_URL || ""}/images/v5/${file}`;
const V = (file) => `${process.env.PUBLIC_URL || ""}/media/v5/${file}`;

/* ── Real photography. w/h are the *display* size used for the aspect ratio and
      the dimension label; the files themselves are ~2x for sharp screens. ── */
export const IMAGES = {
  // Home hero (764 × 432, lower right)
  hero:      { src: R("hero-people.jpg"), w: 764, h: 432, alt: "A sunlit hall with arched doorways, plants and a low sofa in warm terracotta tones" },
  // Home narrative portrait
  story:     { src: R("story-waves.jpg"), w: 800, h: 1000, alt: "Layered, flowing shapes in cream and terracotta" },
  // Home "three ways" cards
  cardPeople:{ src: R("card-people.jpg"), w: 720, h: 900, alt: "A grand hall with a hanging lantern, arches and a chequered floor" },
  cardTeams: { src: R("card-teams.jpg"), w: 720, h: 900, alt: "Hand-painted terracotta strokes radiating like a shared pattern" },
  cardAps:   { src: R("card-aps.jpg"), w: 720, h: 900, alt: "A glass capsule holding a DNA helix, lit from above" },
  // Entry chapter tiles (3:4). Video tiles fall back to their poster.
  tileStudio:   { src: V("dbg-studio.mp4"), video: V("dbg-studio.mp4"), w: 600, h: 800, alt: "Soft marbled shapes in blush and umber" },
  tileProducts: { src: V("office.mp4"), video: V("office.mp4"), w: 600, h: 800, alt: "Hand-painted terracotta strokes in a fan pattern" },
  tileAps:      { src: V("aps-tile.jpg"), video: V("aps-tile.mp4"), w: 600, h: 800, alt: "A glass capsule holding a DNA helix" },
  tileVending:  { src: V("vendbabee-tile.jpg"), video: V("vendbabee-tile.mp4"), w: 600, h: 800, alt: "A glass prism reflecting sky, on a soft grey ground" },

  /* ── Placeholders (used by product pages until product imagery exists) ── */
  caption:   { src: P(764, 432),   w: 764,  h: 432,  alt: "Placeholder image, 764 by 432" },
  wide:      { src: P(1600, 900),  w: 1600, h: 900,  alt: "Placeholder image, 1600 by 900" },
  fullBleed: { src: P(1920, 1080), w: 1920, h: 1080, alt: "Placeholder image, 1920 by 1080" },
  portrait:  { src: P(800, 1000),  w: 800,  h: 1000, alt: "Placeholder image, 800 by 1000" },
  portraitLg:{ src: P(1200, 1500), w: 1200, h: 1500, alt: "Placeholder image, 1200 by 1500" },
  square:    { src: P(1000, 1000), w: 1000, h: 1000, alt: "Placeholder image, 1000 by 1000" },
  card:      { src: P(720, 900),   w: 720,  h: 900,  alt: "Placeholder image, 720 by 900" },
  tile:      { src: P(600, 800),   w: 600,  h: 800,  alt: "Placeholder image, 600 by 800" },
};

export const img = (key) => IMAGES[key] || IMAGES.wide;
